/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { CDNs } from '@ckeditor/ckeditor5-metadata';

export const CKEDITOR5_URL = CDNs.dependencies.ckeditor5;
export const CKEDITOR5_PREMIUM_FEATURES_URL = CDNs.dependencies[ 'ckeditor5-premium-features' ];

const CKEDITOR5_CSS_PATH = '/ckeditor5.css';
const CKEDITOR5_PREMIUM_FEATURES_CSS_PATH = '/ckeditor5-premium-features.css';

export const CKEDITOR5_CSS_URL = `${ CKEDITOR5_URL }${ CKEDITOR5_CSS_PATH }`;
export const CKEDITOR5_PREMIUM_FEATURES_CSS_URL = `${ CKEDITOR5_PREMIUM_FEATURES_URL }${ CKEDITOR5_PREMIUM_FEATURES_CSS_PATH }`;
